import React, { useContext, useEffect, useState } from "react"
import { Dialog, DialogContent, Typography } from "@mui/material"
import { BoxFC, BoxFR } from "components/BoxCustom"
import PaperComponent from "components/PaperComponent"
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import FilePreviewCard from "components/FileUplaod/FilePreviewCard"
import dayjs from "dayjs"

/**
 * READ-ONLY viewer for the files behind ONE expiry date of ONE truck.
 *
 * The four dates in TruckDialog are derived from truck_fix_cost (Menu 7.7), and so are
 * their files, at two levels: ประกันภัย / ประกันสินค้า is one policy PDF for the whole
 * batch (header) while ภาษี / พ.ร.บ. gives each truck its own certificate (item). Both
 * are shown, the truck's own first.
 *
 * Uploading and deleting stay in Menu 7.7 for the same reason the dates are disabled
 * here — the document, its price and its renewal history belong to that module.
 */
const TruckExpFileDialog = ({ tukId, tukFixCostId, title, dialogOpen, setDialogOpen }) => {

  const { ax } = useContext(GlobalStateContext)
  const [hdrData, setHdrData] = useState(null)
  const [itmFilesData, setItmFilesData] = useState([])
  const [hdrFilesData, setHdrFilesData] = useState([])

  useEffect(() => {
    if (!dialogOpen || !tukFixCostId) {
      setHdrData(null)
      setItmFilesData([])
      setHdrFilesData([])
      return
    }
    ax.post("/truck-fix-cost/getTruckFixCostDetail", { TukFixCostId: tukFixCostId }).then(value => {
      if (value.data && value.data.length > 0) {
        const hdr = value.data[0]
        setHdrData(hdr)
        setHdrFilesData(hdr.Files || [])
        const item = (hdr.Items || []).find(itm => itm.TukId === tukId)
        setItmFilesData(item?.Files || [])
      }
    })
  }, [ax, dialogOpen, tukFixCostId, tukId])

  const period = hdrData
    ? `${dayjs(hdrData.StrDte).format("DD/MM/YYYY")} - ${dayjs(hdrData.EndDte).format("DD/MM/YYYY")}`
    : ""

  return (
    <Dialog
      open={dialogOpen}
      onClose={(e, reason) => { if (reason !== "backdropClick") setDialogOpen(false) }}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth='sm'
    >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title={`ไฟล์เอกสาร - ${title || ""}`} onDeleteClick={null} />
      <DialogContent>
        <BoxFC pt={2}>
          {hdrData &&
            <BoxFR sx={{ flexWrap: "wrap", columnGap: 2, rowGap: 0 }}>
              <Typography variant="body2">{hdrData.TukFixCostTypNm}</Typography>
              <Typography variant="body2" color="text.secondary">{period}</Typography>
              {hdrData.DocNo &&
                <Typography variant="body2" color="text.secondary">เลขที่: {hdrData.DocNo}</Typography>}
              {hdrData.SupSNm &&
                <Typography variant="body2" color="text.secondary">{hdrData.SupSNm}</Typography>}
            </BoxFR>
          }
          <BoxFC sx={{ gap: 0 }}>
            <Typography fontWeight="bold" variant="body2">ไฟล์ของรถคันนี้</Typography>
            <FilePreviewCard
              filesData={itmFilesData}
              setFilesData={setItmFilesData}
              pendingFiles={[]}
              setPendingFiles={() => { }}
              onDeleteServerFile={() => Promise.resolve()}
              fileIdKey="TukFixCostItmFileId"
              isReadOnly={true}
            />
          </BoxFC>
          <BoxFC sx={{ gap: 0 }}>
            <Typography fontWeight="bold" variant="body2">ไฟล์เอกสาร (ทั้งใบ)</Typography>
            <FilePreviewCard
              filesData={hdrFilesData}
              setFilesData={setHdrFilesData}
              pendingFiles={[]}
              setPendingFiles={() => { }}
              onDeleteServerFile={() => Promise.resolve()}
              fileIdKey="TukFixCostFileId"
              isReadOnly={true}
            />
          </BoxFC>
          <Typography variant="caption" color="text.secondary">
            เพิ่ม/ลบไฟล์ได้ที่เมนู 7.7 ค่าใช้จ่ายประจำรถ
          </Typography>
        </BoxFC>
      </DialogContent>
      <DialogFooter cancelText="ปิด" handleDialogClose={() => setDialogOpen(false)} />
    </Dialog>
  )
}

export default React.memo(TruckExpFileDialog)
